import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UserAPIModelsERoles } from 'user-ts-ng-client';

import { IconComponent } from '@shared/components/icon/icon.component';
import { IconConfig } from '@shared/models/icon.model';
import { ImpersonationState } from '@shared/models/impersonation.model';

@Component({
  selector: 'srm-impersonation-banner',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './impersonation-banner.component.html',
  styleUrl: './impersonation-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImpersonationBannerComponent {
  @Input({ required: true }) public state!: ImpersonationState;
  @Input() public isStopping: boolean = false;
  @Output() public stopImpersonation = new EventEmitter<void>();

  private readonly roleLabels: Record<string, string> = {
    [UserAPIModelsERoles.GlobalAdmin]: 'GLOBAL ADMIN',
    [UserAPIModelsERoles.SrmContributor]: 'SRM CONTRIBUTOR',
    [UserAPIModelsERoles.OrganizationAdmin]: 'ORG ADMIN',
    [UserAPIModelsERoles.OrganizationContributor]: 'ORG CONTRIBUTOR',
  };

  public readonly iconConfig: IconConfig = {
    iconName: 'heroXCircle',
    alt: 'Impersonation active',
    style: { width: '16px', height: '16px' },
    color: 'var(--srm-color-off-white)',
  };

  public formatRole(role: string): string {
    return (
      this.roleLabels[role] ??
      role
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .trim()
        .toUpperCase()
    );
  }

  public handleStopImpersonation(): void {
    this.stopImpersonation.emit();
  }
}
